import { Button, createStyles, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Paper, Theme, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import * as React from "react";
import Brightness4Icon from '@material-ui/icons/Brightness4'; // toggle dark
import Brightness7Icon from '@material-ui/icons/Brightness7'; // toggle light
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HelpIcon from '@material-ui/icons/Help';
import CategoryIcon from '@material-ui/icons/Category';
import BugReportIcon from '@material-ui/icons/BugReport';
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState, ThemeTypes } from "../../Definitions/Definitions";
import { setPageTheme } from "../../Actions/ActionFunctions";
import { useWindowDimensions } from "./UseWindowDimensions";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        childrenContainer: {
            width: "100%",
            flexGrow: 1
        },
        menuButton: {
            top: 0,
            //width: drawerWidthClosed,
            marginLeft: "auto",
            height: "50px",
            marginBottom: "-0.15rem",
            marginTop: "0.3rem",
            marginRight: "0.15rem"
        },
        paper: {
            //padding: "0.25rem",
            padding: "2% 2% 0 2%",
            position: "fixed",
            width: "100vw",
            top: 0,
            zIndex: 10,
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "center",
            pointerEvents: "none"
        },
        wrapperDiv: {
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
            gap: "0.25rem"
        },
        icon: {
            color: theme.palette.type == "dark" ? "inherit" : "rgba(0,0,0,0.54)"
        },
        background: {
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundImage: "url('images/background-blur.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            zIndex: -5,
            transition: "opacity 200ms ease 0s"
        }
    })
);

export const PageWrapper: React.FunctionComponent<{}> = React.memo(props => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { width, height } = useWindowDimensions();

    const theme = useSelector((state: ReduxState) => state.theme);
    const currentUser = useSelector((state: ReduxState) => state.currentUser);
    const authenticated = useSelector((state: ReduxState) => state.authenticated);

    const small = width < 600;

    const switchTheme = () => {
        if (theme == ThemeTypes.Dark) {
            dispatch(setPageTheme(ThemeTypes.Light));
            localStorage.setItem("theme", ThemeTypes.Light.toString());
        }
        else {
            dispatch(setPageTheme(ThemeTypes.Dark));
            localStorage.setItem("theme", ThemeTypes.Dark.toString());
        }
    }

    const getThemeIcon = () => {
        if (theme == ThemeTypes.Dark)
            return <Brightness7Icon fontSize={small ? "small" : "large"} className={classes.icon} />
        else
            return <Brightness4Icon fontSize={small ? "small" : "large"} className={classes.icon} />
    }

    const shouldUseMainBackground = () => {
        return location.pathname == "/" || location.pathname.startsWith("/join");
    }

    const login = () => {
        history.push("/account/authenticate?redirectURI=" + location.pathname);
        history.go(0);
    }

    return (
        <div style={{ display: "flex" }}>
            <div className={classes.background} style={{ opacity: shouldUseMainBackground() ? "1.0" : "0.0" }} />
            <main className={classes.childrenContainer}>
                <div className={classes.paper}>
                    {location.pathname.startsWith("/play") ?
                        <Tooltip title="Leave Game">
                            <IconButton style={{ padding: "0.5rem", marginLeft: "0.25rem", pointerEvents: "all" }} onClick={() => history.push("/")} color="secondary">
                                <ExitToAppIcon fontSize={small ? "small" : "large"} />
                            </IconButton>
                        </Tooltip>
                        :
                        <div className={classes.wrapperDiv}>
                            <Tooltip title="Feedback">
                                <IconButton style={{ padding: "0.5rem", pointerEvents: "all" }} onClick={() => history.push("/feedback")}>
                                    <BugReportIcon fontSize={"large"} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="About">
                                <IconButton style={{ padding: "0.5rem", pointerEvents: "all" }} onClick={() => history.push("/about")}>
                                    <HelpIcon fontSize={"large"} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Play">
                                <IconButton style={{ padding: "0.5rem", pointerEvents: "all" }} onClick={() => history.push("/")}>
                                    <CategoryIcon fontSize={"large"} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    }
                </div>
                {props.children}
            </main>
        </div>
    );
});

PageWrapper.displayName = "PageWrapper";